/* eslint-disable jsx-a11y/control-has-associated-label */
import { useCallback, useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import Modal from 'react-modal';
import { Tooltip } from '@mui/material';
import { Button } from '../../Buttons/Button';
import { ContentModal, ContentModalButton, Header } from './styles';

interface ModalDisabledProps {
  isOpen: boolean;
  onRequestClose?: () => void;
  onCallBack: () => void;
}

export function ModalTermConditions({ isOpen, onRequestClose, onCallBack }: ModalDisabledProps) {
  const [isDisabled, setIsDisabled] = useState(true);
  const [ref, setRef] = useState<HTMLDivElement>();

  const handleConfirmTermConditions = () => {
    onCallBack();
    onRequestClose?.();
  };

  const handleScroll = () => {
    if (ref) {
      const positionScroll = Math.round(ref.scrollTop + ref.clientHeight);
      const heightScroll = ref.scrollHeight;
      const scrollPorcent = Math.floor((positionScroll / heightScroll) * 100);
      if (scrollPorcent >= 99) {
        setIsDisabled(false);
      }
    }
  };

  const containerRef = useCallback((currentRef: HTMLDivElement) => {
    if (currentRef !== null) setRef(currentRef);
  }, []);

  useEffect(() => {
    if (ref) {
      ref.addEventListener('scroll', handleScroll);
    }
  });

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-term-conditions-content">
      <Header>
        <div className="subHeader">
          <h1>Termos e Condições</h1>
        </div>
        {onRequestClose && (
          <div className="close-div">
            <button type="button" onClick={onRequestClose}>
              <CloseIcon fontSize="small" />
            </button>
          </div>
        )}
      </Header>
      <ContentModal ref={containerRef}>
        <h1>TERMO E CONDIÇÕES GERAIS DE USO - LEGAL HUB</h1>

        <h2>1. DO OBJETO</h2>
        <p>
          A plataforma LEGAL HUB visa licenciar o uso de sua plataforma, fornecendo ferramentas para
          auxiliar e dinamizar o dia a dia dos seus usuários.
        </p>
        <p>
          A plataforma permite que o usuário venda à distância, por meio eletrônico, os seguintes
          serviços: apoio jurídico e assessoria forense em beneficio ao solicitante, relativos a
          processos, procedimentos ou assemelhados que tramitem na Área de Atuação do usuário, como
          por exemplo, mas não se limitando, em Protocolos, Diligências ou Representação em
          Audiências.
        </p>

        <h2>2. DA ACEITAÇÃO</h2>
        <p>
          O presente Termo estabelece obrigações contratadas de livre e espontânea vontade, por
          tempo indeterminado, entre a plataforma e as pessoas físicas ou jurídicas, denominadas
          como usuários.
        </p>
        <p>
          Ao utilizar a plataforma o usuário aceita integralmente as presentes normas e
          compromete-se a observá-las, sob o risco de aplicação das penalidades cabíveis.
        </p>
        <p>
          A aceitação do presente instrumento é imprescindível para o acesso e para a utilização de
          quaisquer serviços fornecidos pela plataforma LEGAL HUB. Caso não concorde com as
          disposições deste instrumento, o usuário não deve utilizá-lo.
        </p>

        <h2>3. DO ACESSO DOS USUÁRIOS</h2>
        <p>
          Serão utilizadas todas as soluções técnicas à disposição do responsável pela plataforma
          para o funcionamento regular do LEGAL HUB, com acesso ao serviço de 24 (vinte e quatro)
          horas por dia. No entanto, a navegação na plataforma poderá ser interrompida, limitada ou
          suspensa para atualizações, modificações ou qualquer ação necessária ao seu bom
          funcionamento.
        </p>
        <p>A plataforma LEGAL HUB, não se responsabiliza nos casos de:</p>
        <ul>
          <li>
            a) Não funcionamento do sistema por ausência de requisitos técnicos mínimos que permitam
            a operação do LEGAL HUB;
          </li>
          <li>
            b) Por problemas definidos como "caso fortuito" ou "força maior" contemplados pelo Art.
            393, do Código Civil Brasileiro;
          </li>
          <li>
            c) Por operação do software por pessoas não autorizadas ou qualquer outra causa em que
            não exista culpa do LEGAL HUB;
          </li>
          <li>
            d) Ocorrências advindas da estrutura do usuário, como oscilação e queda de serviços de
            internet e eventos relacionados a servidores quando aplicável ao caso;
          </li>
          <li>e) Quaisquer tipos de danos indiretos; e,</li>
          <li>h) Pela falha no cumprimento de prazos legais ou contratuais pelo usuário.</li>
        </ul>
        <p>
          A LEGAL HUB adota as medidas de segurança adequadas de acordo com os padrões de mercado
          para a proteção das informações, dados e documentos armazenados na plataforma. Contudo, o
          usuário reconhece que nenhum sistema, biológico ou plataforma está absolutamente imune a
          ataques e/ou invasões de hackers e outros agentes maliciosos, não sendo o LEGAL HUB
          responsável por qualquer exclusão, obtenção, utilização ou divulgação não autorizada de
          informações resultantes de ataques que não poderia razoavelmente evitar por meio dos
          referidos padrões de segurança.
        </p>
        <p>
          O usuário deverá possuir e preservar as configurações mínimas de hardware e de conexão de
          internet exigidas para o pleno funcionamento do LEGAL HUB.
        </p>

        <h2>4. DO CADASTRO</h2>
        <p>
          O acesso às funcionalidades da plataforma exigirá a realização de um cadastro prévio. Ao
          se cadastrar o usuário deverá informar dados completos, recentes e válidos, sendo de sua
          exclusiva responsabilidade manter referidos dados atualizados, bem como o usuário se
          compromete com a veracidade dos dados fornecidos.
        </p>
        <p>
          O usuário se compromete a não informar seus dados cadastrais e/ou de acesso à plataforma a
          terceiros, responsabilizando-se integralmente pelo uso. Mediante a realização do cadastro
          o usuário declara e garante expressamente ser plenamente capaz.
        </p>
        <p>
          Após a confirmação do cadastro, o usuário possuirá um login e uma senha pessoal, a qual
          assegura ao usuário o acesso individual ao LEGAL HUB. Desta forma, compete ao usuário
          exclusivamente a manutenção de referida senha de maneira confidencial e segura.
        </p>
        <p>
          Toda e qualquer atividade realizada com o uso da senha será de responsabilidade do
          usuário, que deverá informar prontamente a plataforma em caso de uso indevido da
          respectiva senha.
        </p>
        <p>
          A conta é pessoal e intransferível, ou seja, o usuário não poderá ceder, vender, emprestar
          ou transferir à terceiros.
        </p>
        <p>
          Caberá exclusivamente ao usuário assegurar acesso à internet sendo que o acesso a
          plataforma poderá ser mediante qualquer equipamento com acesso à internet, uma vez que a
          plataforma é web.
        </p>
        <p>
          O usuário tem ciência de que não há quantidades de pedidos mínimos ou máximos para
          utilização da plataforma, ou seja, o usuário poderá ser demandando ou não para prestar os
          serviços, não tendo a plataforma qualquer responsabilidade.
        </p>

        <h2>5. DAS CONDIÇÕES</h2>
        <p>
          Os serviços divulgados pelos usuários serão prestados somente quando requisitados pelo
          solicitante, via plataforma LEGAL HUB.
        </p>
        <p>
          Ao receber a Solicitação o usuário terá o prazo de 12 (doze) horas para expressar sua
          aceitação, impossibilidade, indisponibilidade ou sua decisão de não cumpri-la. O usuário
          deverá formalizar a aceitação ou recusa via plataforma LEGAL HUB.
        </p>
        <p>
          Caso se depare com qualquer dúvida ou irregularidade ao conferir a Solicitação ou os
          documentos encaminhados para cumpri-la, o usuário deverá, imediatamente, entrar em contato
          com o solicitante via chat dentro da plataforma LEGAL HUB.
        </p>
        <p>
          Competirá ao usuário fazer a conferência dos documentos de representação, conferir se
          todos os documentos exigidos por Lei ou Súmulas dos Tribunais estão sendo juntados, em
          originais ou cópias, conforme esteja prescrito em tais normas, incluindo sem qualquer
          limitação os documentos de representação, as guias de custas ou preparos, e a de depósito
          quando for o caso, inclusive alertando, quando cabível, eventual entendimento específico
          da comarca ou tribunal local.
        </p>
        <p>Especificamente em relação às audiências o usuário deverá:</p>
        <ul>
          <li>a) Revisar a peça de defesa a ser apresentada e conferir os seus anexos;</li>
          <li>
            b) Inteirar-se previamente ao início da sessão de todos os aspectos relativos à matéria
            a ser discutida, das atividades do cliente, do conteúdo da lide e da razão da
            resistência por parte deste último;
          </li>
          <li>
            c) Seguir as orientações do solicitante constantes no campo de observação dentro da
            plataforma, incluindo, sem qualquer limitação, aquelas relativas aos parâmetros para
            acordo, quando isso for autorizado pelo solicitante;
          </li>
          <li>
            d) Esclarecer diretamente com solicitante, previamente ao início da sessão, qualquer
            dúvida que tenha quanto à matéria a ser discutida, atividades do cliente e sua tese de
            defesa; objetivos de eventual prova a ser produzida na audiência, eventuais parâmetros
            para acordo e qualquer outro detalhe que possa influenciar a sua atuação como advogado
            responsável pela representação do cliente no ato;
          </li>
          <li>
            e) Quando requisitado a atuar como preposto deverá o usuário certificar-se de não ter
            ainda atuado no mesmo processo como advogado. Se já tiver sido constituído como patrono
            do cliente através de qualquer documento já juntado aos autos, ou se por qualquer outro
            modo tiver atuado como advogado deverá informar imediatamente o solicitante através do
            chat da plataforma.
          </li>
        </ul>

        <h2>6. DOS PAGAMENTOS</h2>
        <p>
          Os honorários devidos pelo usuário serão pagos em até 90 (noventa dias) contados da
          realização e devolução do ato por meio da plataforma LEGAL HUB, exclusivamente pelo
          solicitante, devendo a solicitação ser considerada encerrada após inclusão do comprovante
          de pagamento na plataforma pelo solicitante. Vale lembrar que a plataforma LEGAL HUB não
          é, de forma alguma, responsável por quaisquer pagamentos!
        </p>
        <p>
          Os pagamentos somente serão devidos depois que o solicitante receber os respectivos
          comprovantes da prestação dos serviços, em meio físico ou eletrônico, incluindo, sem
          qualquer limitação as cópias legíveis de todos os documentos.
        </p>

        <h2>7. DAS RESPONSABILIDADES DO USUÁRIO</h2>
        <p>É de responsabilidade do usuário:</p>
        <ul>
          <li>a) Defeitos ou vícios técnicos originados no próprio sistema do usuário;</li>
          <li>
            b) A correta utilização da plataforma, prezando pelo respeito e cordialidade entre os
            usuários;
          </li>
          <li>
            c) Pelo cumprimento e respeito ao conjunto de regras disposto nesse Termo e na Política
            de Privacidade;
          </li>
          <li>
            d) Atender aos pedidos formulados pelo solicitante no prazo indicado na Solicitação;
          </li>
          <li>e) Seguir a orientação técnica do solicitante;</li>
          <li>
            f) Abster-se de incorrer em qualquer tipo de conflito de interesses, principalmente
            através de:
          </li>
          <ul>
            <li>
              (i) Representação de clientes que tenham interesses contrários aos dos clientes do
              solicitante;
            </li>
            <li>
              (ii) Representação de clientes que estejam em litígio com o solicitante ou com os seus
              clientes;
            </li>
            <li>
              (iii) Oferecimento de prestação de serviços ou concordância em prestar serviços a
              clientes do solicitante;
            </li>
          </ul>
          <li>
            g) Desenvolver os seus trabalhos de conformidade com os mais elevados padrões éticos,
            morais e legais;
          </li>
          <li>
            h) Guardar sigilo de toda e qualquer informação a que tiver acesso, seja de que natureza
            for, e não utilizá-la para nenhum outro fim a não ser a defesa dos interesses do
            solicitante e dos seus clientes;
          </li>
          <li>
            i) Manter registro adequado de todos os compromissos assumidos com o solicitante,
            especialmente a obrigação de comparecer à audiência quando tal ato seja objeto de
            Solicitação de Serviço, e cumprir efetivamente com tais compromissos independentemente
            de qualquer outra comunicação premonitória por parte do solicitante;
          </li>
        </ul>
        <p>
          É de obrigação do usuário assumir qualquer ônus que o solicitante venha a incorrer perante
          seus Clientes em decorrência de perda de prazo para prática de atos processuais e/ou
          providência forense solicitada, que deixarem de ser atendidos por culpa exclusiva do
          usuário. Entende-se como sendo de culpa exclusiva do usuário, entre outras e sem qualquer
          limitação, a perda de prazo processual decorrente da ausência de protocolo tempestivo ou
          qualquer outra diligência ou ainda ausência em audiência que acarrete a preclusão do ato
          processual em si, sendo tal ato, objeto da contratação e à revelia decretada contra o
          cliente por não comparecimento à audiência.
        </p>
        <p>
          O usuário se responsabilizará civilmente por qualquer dano causado ao solicitante devendo
          indenizá-lo.
        </p>
        <p>
          O solicitante, sempre que identificado prejuízo decorrente de culpa exclusiva do usuário,
          fica autorizado a reter o valor dos honorários pelos serviços prestados até o valor pelo
          prejuízo efetivo causado ou da penalidade aplicável, sem redução do seu direito de
          ingressar com outras medidas administrativas ou judiciais cabíveis para o recebimento de
          saldo eventualmente existente contra o usuário.
        </p>

        <h2>8. DO CANCELAMENTO</h2>
        <p>
          O usuário poderá, a qualquer tempo, requerer o cancelamento de seu cadastro, de acordo com
          as seguintes condições:
        </p>
        <ul>
          <li>
            a) A solicitação deve ser feita, exclusivamente, por e-mail para o-serco:
            suporte@legalcontrol.com.br.
          </li>
          <li>
            b) O descadastramento será realizado em até 24 horas após a solicitação, desde que não
            sejam identificados débitos em aberto.
          </li>
          <li>
            c) O cancelamento só será efetivado após a regularização dos débitos pendentes no
            cadastro do usuário.
          </li>
        </ul>
        <p>
          O acesso a plataforma LEGAL HUB dependerá do cumprimento do presente Termo e da Política
          de Privacidade de Dados, em caso de violação de quaisquer regras, o acesso à plataforma
          será cancelado imediatamente e o usuário não terá mais acesso.
        </p>

        <h2>9. DO SUPORTE</h2>
        <p>
          Em caso de qualquer dúvida, sugestão ou problema com a utilização da plataforma LEGAL HUB,
          o usuário poderá entrar em contato com o suporte, através e-mail
          contato.legalhub@legalcontrol.com.br.
        </p>
        <p>
          Estes serviços de atendimento ao usuário somente estarão disponíveis de segunda-feira a
          sexta-feira das 09 horas às 18horas, ou seja, dentro do horário comercial, exceto feriado.
        </p>

        <h2>10. DAS ALTERAÇÕES</h2>
        <p>
          Os itens descritos no presente Termo poderão sofrer alterações, unilateralmente e a
          qualquer tempo pela empresa, para adequar ou modificar a plataforma LEGAL HUB, bem como
          para atender novas exigências legais.
        </p>
        <p>
          A plataforma LEGAL HUB poderá, deixar de ser fornecida, a qualquer tempo, sem aviso prévio
          e de forma unilateral pela empresa.
        </p>

        <h2>11. DA POLÍTICA DE PRIVACIDADE DE DADOS</h2>
        <p>
          Além do presente Termo, o usuário deverá consentir com as disposições contidas na Política
          de Privacidade.
        </p>

        <h2>12. DO FORO</h2>
        <p>
          Fica eleito o foro da Comarca de São Paulo/SP como único competente para dirimir quaisquer
          dúvidas ou conflitos decorrentes do presente instrumento.
        </p>

        <p>
          <strong>AO CHECAR O ITEM "EU CONCORDO" SIGNIFICA QUE VOCÊ (USUÁRIO):</strong>
        </p>
        <ul>
          <li>- LEU E COMPREENDEU TODO O CONTEÚDO DESTE TERMO;</li>
          <li>- ESTÁ DE PLENO ACORDO COM TODAS AS CONDIÇÕES DESTE TERMO; E,</li>
          <li>- TEM CAPACIDADE LEGAL PARA SE RESPONSABILIZAR PELAS OBRIGAÇÕES AQUI ASSUMIDAS.</li>
        </ul>
        <h1>POLÍTICA DE PRIVACIDADE</h1>
        <h1>1.OBJETIVO</h1>
        <p>
          No <strong>LEGAL HUB</strong>, privacidade e segurança são prioridades e nos comprometemos
          com a transparência no tratamento de seus dados pessoais. Por isto, esta política tem o
          objetivo de estabelecer as diretrizes para a coleta, uso, armazenamento, tratamento e
          proteção dos dados pessoais de usuários e clientes.
        </p>
        <p>
          Assim, ao se cadastrar no sistema <strong>LEGAL HUB</strong>, você entende que coletaremos
          e usaremos suas informações pessoais nas formas descritas nesta Política, sob as normas de
          Proteção de Dados (LGPD, Lei Federal 13.709/2018) e demais legislações brasileiras
          aplicáveis.
        </p>
        <h1>2.REFERÊNCIAS</h1>
        <ul>
          <li>Lei 13.709/2018 - Lei Geral de Proteção de Dados.</li>
        </ul>
        <h1>3.DEFINIÇÕES</h1>
        <p>
          <strong>Usuário</strong>: todas as pessoas físicas que se cadastrarem no sistema Legal
          Hub, maiores de 18 (dezoito) anos ou emancipadas e totalmente capazes de praticar os atos
          da vida civil ou os absolutamente ou relativamente incapazes devidamente representados ou
          assistidos.
        </p>
        <p>
          <strong>Dados Pessoais:</strong> significa quaisquer informações fornecidas/cadastradas no{' '}
          <strong>LEGAL HUB</strong>, por qualquer meio, ainda que públicos, que: (I) identifiquem,
          isoladamente ou quando usadas em combinação com outras informações tratadas pelo{' '}
          <strong>LEGAL HUB</strong> identifiquem um indivíduo; ou (II) por meio das quais a
          identificação ou informações de contato de uma pessoa física possam ser derivadas. Os
          Dados Pessoais podem estar em qualquer mídia ou formato, inclusive registros eletrônicos
          ou computadorizados, bem como em arquivos baseados em papel.
        </p>
        <p>
          <strong>Finalidade:</strong> o objetivo é a contratação dos serviços das pessoas
          cadastradas no sistema <strong>LEGAL HUB</strong>.
        </p>
        <p>
          <strong>Necessidade:</strong> justificativa pelo qual é estritamente necessário coletar
          dados pessoais, para atingir a finalidade, evitando-se a coleta excessiva.
        </p>
        <p>
          <strong>Bases legais</strong>: fundamentação legal que torna legítimo o tratamento de
          dados pessoais para uma determinada finalidade prévia por parte do{' '}
          <strong>LEGAL HUB</strong>.
        </p>
        <p>
          <strong>Consentimento:</strong> autorização expressa e inequívoca dada pelo Usuário
          titular do dado pessoal para que o <strong>LEGAL HUB</strong> trate seus dados pessoais
          para uma finalidade previamente descrita, na qual a base legal necessária para o ato
          demande a autorização expressa do titular.
        </p>
        <h1>4.DIRETRIZES GERAIS E ESPECÍFICAS</h1>
        <p>
          Esta política se aplica, em geral, a todos os Usuários e potenciais Usuários dos serviços
          oferecidos pelo <strong>LEGAL HUB</strong> e resume como poderemos coletar, produzir,
          receptar, classificar, utilizar, acessar, reproduzir, transmitir, distribuir, processar,
          arquivar, armazenar, eliminar, avaliar ou controlar a informação, modificar, comunicar,
          transferir, difundir ou extrair os dados coletados, incluindo as informações de
          identificação pessoal, de acordo com as bases legais aplicáveis e todas as leis de
          privacidade e proteção de dados em vigor.
        </p>
        <p>
          Caso o Usuário não se enquadre nas diretrizes acima e/ou não concorde, ainda que em parte,
          com as condições contidos nesta Política de Privacidade, não deverá participar, acessar
          e/ou utilizar os serviços oferecidos pelo <strong>LEGAL HUB</strong>.
        </p>
        <h1>Dos Cookies</h1>
        <p>
          As informações pessoais significam dados relacionados a um indivíduo e que identificam
          esse indivíduo, direta ou indiretamente, como seu nome ou suas informações de contato.
        </p>
        <p>
          Um cookie é um dado que a plataforma solicita ao seu navegador para armazenar no seu
          computador ou dispositivo móvel.
        </p>
        <p>
          A plataforma usa cookies para melhorar o desempenho e aprimorar a sua experiência de
          navegação permitindo que a plataforma guarde as ações do usuário ao longo do tempo.
        </p>
        <p>
          A maioria dos navegadores da Internet aceitam cookies, entretanto, os usuários podem
          configurar seus navegadores para recusar certos tipos de cookies ou cookies específicos.
          Além disso, podem apagar os cookies a qualquer momento.
        </p>
        <h1>4.1.Coleta e Uso de Informações Pessoais</h1>
        <p>
          O <strong>LEGAL HUB</strong> apenas trata Dados Pessoais em situações em que está
          autorizado legalmente ou mediante o expresso e inequívoco consentimento do Usuário.
        </p>
        <p>
          Assim, o Usuário está ciente de que fornece informação de forma consciente e voluntária
          por meio do preenchimento de seus dados no sistema.
        </p>
        <p>
          Conforme descrito na presente Política, o <strong>LEGAL HUB</strong> tem bases legais para
          coletar, produzir, receptar, classificar, utilizar, acessar, reproduzir, transmitir,
          distribuir, processar, arquivar, armazenar, eliminar, avaliar ou controlar a informação,
          modificar, comunicar, transferir, difundir ou extrair dados sobre o Usuário.
        </p>
        <p>
          Assim, em consonância com a Lei Geral de Proteção de Dados, seus dados só serão coletados,
          tratados e armazenados mediante prévio e expresso consentimento, evidenciando o
          compromisso de transparência e boa-fé do <strong>LEGAL HUB</strong>, para com seus
          usuários, seguindo as regulações legislativas pertinentes.
        </p>
        <h1>4.2.Compartilhamento e tratamento de Dados Pessoais</h1>
        <p>
          O <strong>LEGAL HUB</strong> não disponibilizará Dados Pessoais coletados para outras
          finalidades que não sejam para a viabilização da prestação de serviços, nos comprometendo,
          no entanto, a implementar todas as medidas técnicas e organizacionais apropriadas, de
          forma a proteger todos os dados coletados.
        </p>
        <p>
          O <strong>LEGAL HUB</strong> poderá divulgar os Dados Pessoais coletados a terceiros, nas
          seguintes situações e nos limites exigidos e autorizados pela Lei:
        </p>
        <div>
          <ol>
            <li>
              Com os seus clientes e parceiros quando necessário e/ou apropriado à prestação de
              serviços relacionados;
            </li>
            <li>
              Com as empresas e indivíduos contratados para a execução de determinadas atividades e
              serviços em nome do <strong>LEGAL HUB</strong>;
            </li>
            <li>
              III. Com fornecedores e parceiros para consecução dos serviços contratados com o
              <strong> LEGAL HUB</strong> (como tecnologia da informação, contabilidade, entre
              outros);
            </li>
            <li>
              Para propósitos administrativos como: pesquisa, planejamento, desenvolvimento de
              serviços, segurança e gerenciamento de risco.
            </li>
            <li>
              Quando necessário em decorrência de obrigação legal, determinação de autoridade
              competente, ou decisão judicial.
            </li>
          </ol>
        </div>
        <p>
          Nas hipóteses de compartilhamento de Dados Pessoais com terceiros, todos os sujeitos
          mencionados nos itens I a V deverão utilizar os Dados Pessoais partilhados de maneira
          consistente e de acordo com os propósitos para os quais foram coletados (ou com os quais o
          Usuário consentiu previamente) e de acordo com o que foi determinado por esta Política de
          Privacidade.Nas hipóteses de compartilhamento de Dados Pessoais com terceiros, todos os
          sujeitos mencionados nos itens I a V deverão utilizar os Dados Pessoais partilhados de
          maneira consistente e de acordo com os propósitos para os quais foram coletados (ou com os
          quais o Usuário consentiu previamente) e de acordo com o que foi determinado por esta
          Política de Privacidade.
        </p>
        <p>
          Em certas circunstâncias, o <strong>LEGAL HUB</strong> poderá divulgar Dados Pessoais, na
          medida necessária ou apropriada, para órgãos governamentais, consultores e outros
          terceiros com o objetivo de cumprir com a legislação aplicável ou com uma ordem ou
          intimação judicial ou, ainda, se acreditar de boa-fé que tal ação seja necessária para:
        </p>
        <div>
          <ol>
            <li>Cumprir com uma legislação que exija tal divulgação;</li>
            <li>
              Investigar, impedir ou tomar medidas relacionadas a atividades ilegais suspeitas ou
              reais ou para cooperar com órgãos públicos ou para proteger a segurança nacional;
            </li>
            <li>Execução de seus contratos;</li>
            <li>
              Investigar e se defender contra quaisquer reivindicações ou alegações de terceiros;
            </li>
            <li>Proteger a segurança ou a integridade dos serviços;</li>
            <li>
              Exercer ou proteger os direitos, a propriedade e a segurança do
              <strong> LEGAL HUB</strong> e suas empresas coligadas;
            </li>
            <li>
              Proteger os direitos e a segurança pessoal de seus funcionários, usuários ou do
              público;
            </li>
            <li>
              Em caso de venda, compra, fusão, reorganização, liquidação ou dissolução do
              <strong> LEGAL HUB</strong>.
            </li>
          </ol>
        </div>
        <p>
          O <strong>LEGAL HUB</strong> poderá cientificar os respectivos Usuários sobre eventuais
          demandas legais que resultem na divulgação de informações pessoais, nos termos do que foi
          exposto, a menos que tal cientificação seja vedada por lei ou proibida por mandado
          judicial ou, ainda, se a requisição for emergencial.
        </p>
        <h1>4.3.Armazenamento e Segurança dos Dados Pessoais</h1>
        <p>
          Os dados coletados, inclusive os Dados Pessoais, serão utilizados e armazenados durante o
          tempo necessário para que as finalidades elencadas na presente Política de Privacidade
          sejam atingidas, considerando os direitos dos titulares dos dados e dos controladores.
        </p>
        <p>
          De modo geral, seus dados serão mantidos enquanto a relação entre você e o
          <strong> LEGAL HUB</strong> perdurar. Findado o período de armazenamento dos dados
          pessoais, estes serão excluídos de nossas bases de dados ou anonimizados, ressalvadas as
          hipóteses legalmente previstas no artigo 16 da Lei Geral de Proteção de Dados - LGPD, a
          saber:
        </p>
        <div>
          <ol>
            <li>Cumprimento de obrigação legal ou regulatória pelo controlador;</li>
            <li>
              Estudo por órgão de pesquisa, garantida, sempre que possível, a anonimização dos dados
              pessoais;
            </li>
            <li>
              Transferência a terceiro, desde que respeitados os requisitos de tratamento de dados
              dispostos nesta Lei; ou
            </li>
            <li>
              Uso exclusivo do controlador, vedado seu acesso por terceiro, e desde que anonimizados
              os dados.
            </li>
          </ol>
        </div>
        <p>
          Isto é, informações pessoais sobre você que sejam imprescindíveis para o cumprimento de
          determinações legais, judiciais e administrativas e/ou para o exercício do direito de
          defesa em processos judiciais e administrativos serão mantidas, a despeito da exclusão dos
          demais dados.
        </p>
        <p>
          O <strong>LEGAL HUB</strong> se compromete a adotar as melhores posturas para evitar
          incidentes de segurança. Contudo, é necessário destacar que nenhuma página virtual é
          inteiramente segura e livre de riscos. É possível que, apesar de todos os nossos
          protocolos de segurança, problemas de culpa exclusivamente de terceiros ocorram, como
          ataques cibernéticos de hackers, ou também em decorrência da negligência ou imprudência do
          próprio usuário.
        </p>
        <p>
          Em caso de incidentes de segurança que possa gerar risco ou dano relevante, nos
          comprometemos a comunicar nossos usuários e a Autoridade Nacional de Proteção de Dados
          sobre o ocorrido, em consonância com as disposições da Lei Geral de Proteção de Dados.
        </p>
        <h1>4.4.Direitos do Usuários</h1>
        <p>
          O <strong>LEGAL HUB</strong> assegura a seus usuários seus direitos de titular previstos
          no artigo 18 da Lei Geral de Proteção de Dados. Dessa forma, você pode, de maneira
          gratuita e a qualquer tempo:
        </p>
        <ol>
          <li>
            <strong>Confirmar a existência de tratamento de dados</strong>, de maneira simplificada
            ou em formato claro e completo.
          </li>
          <li>
            <strong>Corrigir seus dados</strong>, ao solicitar a edição, correção ou atualização
            destes.
          </li>
          <li>
            <strong>Eliminar seus dados</strong> tratados a partir de seu consentimento, exceto nos
            casos previstos em lei.
          </li>
          <li>
            <strong>Informar-se sobre a possibilidade de não fornecer seu consentimento</strong> e
            sobre as consequências da negativa.
          </li>
        </ol>
        <p>
          Para o exercício destes direitos, você deve entrar em contato com o
          <strong> LEGAL HUB</strong>, através dos meios disponíveis nesta Política.
        </p>
        <p>
          Para estas situações e de forma a garantir a sua correta identificação como titular dos
          dados pessoais objeto da solicitação, é possível que solicitemos documentos ou demais
          comprovações que possam garantir sua identidade. Nessa hipótese, você será informado
          previamente.
        </p>
        <h1>4.5.Alterações desta Política de Privacidade</h1>
        <p>
          Reservamos o direito de modificar essa Política de Privacidade a qualquer tempo,
          principalmente em função da adequação a eventuais alterações feitas em nosso sistema ou em
          âmbito legislativo. Recomendamos que você a revise com frequência.
        </p>
        <p>
          Ao utilizar nossos serviços e fornecer seus dados pessoais após tais modificações, você as
          consente.
        </p>
        <h1>4.6.Responsabilidades e Contato</h1>
        <p>
          Nos comprometemos em manter esta Política de Privacidade atualizada, observando suas
          disposições e zelando por seu cumprimento, assumindo o compromisso de buscar condições
          técnicas e organizativas seguramente aptas a proteger todo o processo de tratamento de
          dados.
        </p>
        <p>
          Caso a Autoridade Nacional de Proteção de Dados exija a adoção de providências em relação
          ao tratamento de dados realizado pelo <strong>LEGAL HUB</strong>, comprometemo-nos a
          segui-las.
        </p>
        <p>
          Conforme já mencionado, embora adotemos elevados padrões de segurança a fim de evitar
          incidentes, não há nenhuma página virtual inteiramente livre de riscos. Nesse sentido, não
          nos responsabilizamos por:
        </p>
        <div>
          <ol>
            <li>
              Quaisquer consequências decorrentes da negligência, imprudência ou imperícia dos
              usuários em relação a seus dados individuais. Garantimos e nos responsabilizamos
              apenas pela segurança dos processos de tratamento de dados e do cumprimento das
              finalidades descritas no presente instrumento.
              <p>
                Destacamos que a responsabilidade em relação à confidencialidade dos dados de acesso
                é do usuário.
              </p>
            </li>
            <li>
              Ações maliciosas de terceiros, como ataques de hackers, exceto se comprovada conduta
              culposa ou deliberada do <strong>LEGAL HUB</strong>.
              <p>
                Destacamos que em caso de incidentes de segurança que possam gerar risco ou dano
                relevante aos nossos usuários, comunicaremos aos afetados e a Autoridade Nacional de
                Proteção de Dados sobre o ocorrido e cumpriremos as providências necessárias.
              </p>
            </li>
            <li>
              Inveracidade das informações inseridas pelo usuário nos registros necessários e
              quaisquer consequências decorrentes de informações falsas ou inseridas de má-fé, sendo
              estas, de inteira responsabilidade do usuário.
            </li>
          </ol>
        </div>
        <p>
          Caso tenha dúvidas sobre esta Política de Privacidade, sobre os dados pessoais que
          tratamos ou ainda, para o exercício de seus direitos, você pode entrar em contato com a
          nossa equipe, através do e-mail contato.legalhub@legalcontrol.com.br.
        </p>
        <h1>4.7.Foro de Eleição</h1>
        <p>
          Esta política está sujeita à Lei da República Federativa do Brasil e o Foro da Comarca de
          São Paulo é competente para dirimir qualquer controvérsia com relação à mesma.
        </p>
      </ContentModal>
      <ContentModalButton>
        <Tooltip
          disableInteractive
          title={isDisabled ? 'Leia todo o termo de condições gerais para confirmar' : ''}>
          <div className="containerButton">
            <Button
              id="confirm-term-conditions"
              disabled={isDisabled}
              onClick={handleConfirmTermConditions}
              text="Confirmar"
              dimensions={{ width: '50%', height: '2rem' }}
              color="background_white"
              backgroundHoverColor="primary"
              background="secondary"
            />
          </div>
        </Tooltip>
      </ContentModalButton>
    </Modal>
  );
}
